import React, { Component, Fragment } from "react"
import { withRouter } from "react-router-dom"
import styles from "./Hero.css"
import CategoryOrSubBrand from "./partials/CategoryOrSubBrand"
import Framer from "../Framer/Framer"
import { FrameAnimation, FrameStates } from "../../constants/consts-types"
import PropTypes from "prop-types"
import {
  getViewPortHeight,
  getViewPortWidth,
  isDesktop,
} from "../../services/service-utils"
import Review from "../Review/Review"
import { TypeListItem } from "../../constants/consts-prop-types"
import { loadImage } from "../../services/service-image-loader"
import BackgroundImageParallax from "./partials/BackgroundImageParallax"
import HeaderBoldLightSub from "./partials/HeaderBoldLightSub"
import CTAs from "./partials/CTAs"
import HeroVideoPlayer from "./partials/HeroVideoPlayer";

class HeroSection extends Component {
  static propTypes = {
    data: TypeListItem,
    frameFrom: PropTypes.string,
    frameTo: PropTypes.string,
    frameLeave: PropTypes.string,
  }

  static defaultProps = {
    frameFrom: FrameStates.INIT_SECTION,
    frameTo: FrameStates.SECTION,
    frameLeave: FrameStates.LEAVE_SECTION,
  }

  constructor(props) {
    super(props)

    this.state = {
      frame: props.frameFrom,
      imageSrc: null,
      isDesktop: isDesktop(),
      viewportWidth: getViewPortWidth(),
      viewportHeight: getViewPortHeight(),
    }

    this.onScroll = this.onScroll.bind(this)
    this.onResize = this.onResize.bind(this)
    this.moveHero = this.moveHero.bind(this)
    this.renderReview = this.renderReview.bind(this)
  }

  componentDidMount() {
    this.resetText()

    window.addEventListener("scroll", this.onScroll)
    window.addEventListener("resize", this.onResize)

    this.setState({
      viewportHeight: getViewPortHeight(),
    })

    loadImage(this.props.data.image_url, this)

    const videoId = this.props.data && this.props.data.video && this.props.data.video.video_id
    setTimeout(
      () => {
        if (this.mainNode) {
          this.setState(
            {
              frame: this.props.frameTo,
            },
            this.enterText
          )
        }
      },
      videoId ? 0 : FrameAnimation.ENTER_DELAY
    )
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onResize)
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.image_url !== prevProps.data.image_url) {
      loadImage(this.props.data.image_url, this)
    }
  }

  onResize() {
    if (this.state.viewportWidth === getViewPortWidth()) return

    this.setState({
      isDesktop: isDesktop(),
      viewportWidth: getViewPortWidth(),
      viewportHeight: getViewPortHeight(),
    })
  }

  onScroll() {
    window.requestAnimationFrame(this.moveHero)
  }

  resetText() {
    window.TweenLite.set(this.nodeCat, {
      opacity: 0,
      transform: "translateX(20px)",
    })
    window.TweenLite.set(this.nodeHead, {
      opacity: 0,
      transform: "translateX(20px)",
    })
    if (this.nodeCTAs)
      window.TweenLite.set(this.nodeCTAs, {
        opacity: 0,
        transform: "translateX(20px)",
      })
    if (this.nodeReview0)
      window.TweenLite.set(this.nodeReview0, {
        opacity: 0,
        transform: "translateX(20px)",
      })
    if (this.nodeReview1)
      window.TweenLite.set(this.nodeReview1, {
        opacity: 0,
        transform: "translateX(20px)",
      })
  }

  enterText() {
    const time = 0.9
    const del = "-=.4"
    this.tl = new window.TimelineLite()
    this.tl.stop()
    if (this.nodeCat)
      this.tl.add(
        window.TweenLite.to(this.nodeCat, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    if (this.nodeHead)
      this.tl.add(
        window.TweenLite.to(this.nodeHead, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    if (this.nodeCTAs)
      this.tl.add(
        window.TweenLite.to(this.nodeCTAs, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    if (this.nodeReview0)
      this.tl.add(
        window.TweenLite.to(this.nodeReview0, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    if (this.nodeReview1)
      this.tl.add(
        window.TweenLite.to(this.nodeReview1, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    window.TweenLite.to(this.tl, 2, { progress: 1, delay: 0.25 })
  }

  moveHero() {
    this.setState({
      offsetY: Math.min(window.scrollY / 8, 150),
    })
  }

  renderReview(review, idx, styleReviewWrappers) {
    if (idx > 1) return null
    return (
      <div
        ref={(node) => (this[`nodeReview${idx}`] = node)}
        key={idx}
        className="col-xs-11 col-md-2 col-md-offset-1"
        style={styleReviewWrappers}
      >
        <Review data={review} />
      </div>
    )
  }

  render() {
    const subBrand = this.props.currentRoute.section.name

    const {
      category,
      header_bold,
      header_light,
      header_sub,
      cta_primary,
      cta_secondary,
      colors,
      reviews,
      url,
      video,
    } = this.props.data

    const { imageSrc, viewportHeight, frame, isDesktop } = this.state

    const hasReviews = Boolean(reviews && reviews.length > 0)

    const stylesHero = {
      height: `${viewportHeight}px`,
      color: colors && colors.foreground ? colors.foreground : "",
      backgroundColor: colors && colors.background ? colors.background : "",
    }

    const styleReviewWrappers = isDesktop ? {} : { marginTop: "1rem" }
    const videoId = video && video.video_id

    return (
      <section
        ref={(node) => (this.mainNode = node)}
        className={hasReviews ? styles.HeroSectionReviews : styles.Hero}
        style={stylesHero}
      >
        {videoId ? (
          <HeroVideoPlayer video={video} />
        ) : (
          <Fragment>
            <Framer state={frame} colors={colors} />
            <BackgroundImageParallax imageSrc={imageSrc} />
          </Fragment>
        )}

        <article className={styles.content}>
          <div className={`container-fluid ${styles.frontContainerFluid}`}>
            <div className="row">
              <div className="col-xs-11 col-md-5">
                <CategoryOrSubBrand
                  ref={(node) => (this.nodeCat = node)}
                  category={category}
                  subBrand={subBrand}
                  url={url}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-11 col-md-5">
                <HeaderBoldLightSub
                  ref={(node) => (this.nodeHead = node)}
                  header_bold={header_bold}
                  header_light={header_light}
                  header_sub={header_sub}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-11 col-md-5">
                <CTAs
                  ref={(node) => (this.nodeCTAs = node)}
                  cta_primary={cta_primary}
                  cta_secondary={cta_secondary}
                  cta_title={header_bold}
                />
              </div>

              {hasReviews &&
                !isDesktop &&
                this.renderReview(reviews[0], 0, styleReviewWrappers)}

              {hasReviews &&
                isDesktop &&
                reviews.map((review, idx) =>
                  this.renderReview(review, idx, styleReviewWrappers)
                )}
            </div>
          </div>
        </article>
      </section>
    );
  }
}

export default withRouter(HeroSection)



// WEBPACK FOOTER //
// ./src/components/Hero/HeroSection.js